import {action, computed, observable} from 'mobx';
import {types, endpoints} from "shared/core";
import {NotificationRecipient} from "stores/documents";
import {DomainStore} from 'shared/store';
import {User} from "stores/users";
import _ from 'lodash';

class EmployeeDocumentState {
  store = new DomainStore();

  @observable document;
  @observable users = [];

  @action async load(){
    await this.store._compose([
      endpoints.USERS.ACTIVE
    ])

    this.users = this.store._getAll(types.USER, User);
  }

  receiveProps({document}) {
    this.document = document;
  }

  @computed get recipientOptions() {
    return [
      new NotificationRecipient({
        recipientType: 'manager'
      }),
      ...this.users.map(user => new NotificationRecipient(
        {
          recipientType: 'specific_user',
          user: user
        }
      ))
    ]
  }
}

export default EmployeeDocumentState;
